import { simplifyDecimal } from "components/FormattedMoney/utils";

const getDisplayFeeString = (fee = 0, tiliaFeePercentage, USDFormatter) => {
  // If both tilia fee and fee exist
  if (tiliaFeePercentage && fee) {
    return `${tiliaFeePercentage}% + ${simplifyDecimal(USDFormatter(fee * 100))}`;
  }
  // Only tilia fee exists
  else if (tiliaFeePercentage) {
    return `${tiliaFeePercentage}%`;
  }
  // Default to displaying fee
  else {
    return `${simplifyDecimal(USDFormatter(fee * 100))}`;
  }
};

export default getDisplayFeeString;
